<template>
  <!--手机端-->
  <div class="contact-mobile" v-if="isMobile">
    <div class="img-bg posRelative" @contextmenu.prevent="disableContextMenu">
      <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/banner_jrwm.png" class="posAbsoluteAll"
           draggable="false">
      <div class="banner-text colorfff">
        <div class="font-size60 font-bold">加入我们</div>
        <div class="line1 margin-top30 margin-bottom30"></div>
        <div class="font-size30">JOIN US</div>
      </div>
    </div>

    <div class="main-content" :class="{'mainAdd': showDetail == true}">
      <!-- 列表 -->
      <div v-show="!showDetail">
        <div class="column-me row-center margin-top50">
          <div class="font-size40 font-bold color000" v-if="language==='0'">和优秀的人 做有挑战的事</div>
          <div class="font-size40 font-bold color000" v-if="language==='1'">meet the challenge with great people
          </div>
          <div class="font-size20 color666 margin-top20">CHENGLONG</div>
        </div>
        <div class="mLR30 margin-top50">
          <div class="item-contact column-me posRelative" v-for="(item, index) in contactArray" :key="index"
               @mouseenter="mouseenter(index)" @mouseleave="mouseleave" @click="clickItem(item,index)">
            <div class="font-size30 font-bold color000" :class="{'colorRed':nowIndex===index}" v-if="language==='0'">
              {{ item.name }}
            </div>
            <div class="font-size30 font-bold color000" :class="{'colorRed':nowIndex===index}" v-if="language==='1'">
              {{ item.name_en }}
            </div>
            <div class="line-grey-heng margin-top30"></div>
            <div class="line-title margin-top25" v-if="language==='0'">工作内容</div>
            <div class="line-title margin-top25" v-if="language==='1'">Work Content</div>
            <div class="font-size24 lineH50 color666 margin-top27 line3" v-if="language==='0'">
              {{ item.work_content }}
            </div>
            <div class="font-size24 lineH50 color666 margin-top27 line3" v-if="language==='1'">
              {{ item.work_content_en }}
            </div>
            <div class="row-me center-all look-div" :class="{'look-div-active':nowIndex===index}">
              <span v-if="language==='0'">查看详情</span>
              <span v-if="language==='1'">Discover More</span>
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk2.png"
                   class="width18 height5 margin-left10" draggable="false"
                   v-if="nowIndex===index">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk1.png"
                   class="width18 height5 margin-left10" draggable="false" v-else>
            </div>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_zw.png" class="img-icon"
                 draggable="false">
          </div>
        </div>
        <div class="row-me center-all margin-top50 margin-bottom100">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="prev, pager, next" :total="total" background>
          </el-pagination>
        </div>
      </div>
      <!-- 新闻详情 -->
      <div v-if="showDetail">
        <div class="tab-div row-me row-center">
          <div class="margin-left30">
            <el-breadcrumb separator=">">
              <el-breadcrumb-item :to="{ path: '/home' }">
                <span class="font-size20">{{ language === '0' ? '首页' : 'Homepage' }}</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
						<span class="pointer font-size20" @click="clickContact">
							{{ language === '0' ? '加入我们' : 'JOIN US' }}</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                <span class="font-size20 font-bold" style="color: #0B0F0F;" v-if="language==='0'">{{
                    selectItem.name
                  }}</span>
                <span class="font-size20 font-bold" style="color: #0B0F0F;" v-if="language==='1'">{{
                    selectItem.name_en
                  }}</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="mLR30">
          <div class="font-size40 font-bold margin-top50" v-if="language==='0'">{{ selectItem.name }}</div>
          <div class="font-size40 font-bold margin-top100" v-if="language==='1'">{{ selectItem.name_en }}</div>
          <div class="font-size20 color666 margin-top20">CHENGLONG</div>
          <div class="line-red-heng margin-top20"></div>
          <div class="font-size30 color000 margin-top40" v-if="language==='0'">工作内容</div>
          <div class="font-size30 color000 margin-top40" v-if="language==='1'">Work Content</div>
          <div class="font-size26 color666 margin-top20 lineH50 html-show" v-html="selectItem.work_content"
               v-if="language==='0'"></div>
          <div class="font-size26 color666 margin-top20 lineH50 html-show" v-html="selectItem.work_content_en"
               v-if="language==='1'"></div>
          <div class="font-size30 color000 margin-top50" v-if="language==='0'">职位要求</div>
          <div class="font-size30 color000 margin-top50" v-if="language==='1'">Job Requirements</div>
          <div class="font-size26 color666 margin-top20 lineH50 html-show" v-html="selectItem.need"
               v-if="language==='0'"></div>
          <div class="font-size26 color666 margin-top20 lineH50 html-show" v-html="selectItem.need_en"
               v-if="language==='1'"></div>
          <div class="font-size30 color000 font-bold margin-top50" v-if="language==='0'">
            如果您想申请，请直接与招聘部门联系
          </div>
          <div class="font-size30 color000 font-bold margin-top50" v-if="language==='1'">
            Please contact the recruitment department directly if you want to apply.
          </div>
          <div class="margin-top30">
            <div class="grey-div1 row-me row-center">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_youxiang.png"
                   class="img90 margin-left20" draggable="false">
              <div class="flex1 margin-left30">
                <div class="font-size20 color000" v-if="language==='0'">简历发送至邮箱</div>
                <div class="font-size20 color000" v-if="language==='1'">
                  Please send your resume to the mailbox
                </div>
                <div class="font-size24 color000 font-bold margin-top20">huanshuai.zhao@chenglonggroup.cn</div>
              </div>
            </div>
            <div class="grey-div2 row-me row-center margin-top30">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_dianhua.png"
                   class="img90 margin-left20" draggable="false">
              <div class="flex1 margin-left30">
                <div class="font-size20 color000" v-if="language==='0'">拨打电话给招聘人员</div>
                <div class="font-size20 color000" v-if="language==='1'">Call the recruiter</div>
                <div class="font-size24 color000 font-bold margin-top20">+86-532-6776-1685</div>
              </div>
            </div>
          </div>
          <div class="margin-top50"></div>
        </div>
      </div>
    </div>
  </div>

  <!--电脑端-->
  <div class="contact" v-else>
    <div class="img-bg posRelative" @contextmenu.prevent="disableContextMenu">
      <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/banner_jrwm.png" class="posAbsoluteAll"
           draggable="false">
      <div class="banner-text colorfff">
        <div class="font-size60 font-bold">加入我们</div>
        <div class="line1 margin-top30 margin-bottom30"></div>
        <div class="font-size30">JOIN US</div>
      </div>
    </div>

    <div class="main-content" :class="{'mainAdd': showDetail == true}">
      <!-- 列表 -->
      <div v-show="!showDetail">
        <div class="column-me row-center margin-top100">
          <div class="font-size40 font-bold color000" v-if="language==='0'">和优秀的人 做有挑战的事</div>
          <div class="font-size40 font-bold color000" v-if="language==='1'">meet the challenge with great people
          </div>
          <div class="font-size20 color666 margin-top20">CHENGLONG</div>
        </div>
        <div class="margin-left200 margin-right200 row-me flex-wrap margin-top100">
          <div class="item-contact column-me posRelative" v-for="(item, index) in contactArray" :key="index"
               @mouseenter="mouseenter(index)" @mouseleave="mouseleave" @click="clickItem(item,index)">
            <div class="font-size30 font-bold color000 line2" :class="{'colorRed':nowIndex===index}"
                 v-if="language==='0'">
              {{ item.name }}
            </div>
            <div class="font-size30 font-bold color000 line2" :class="{'colorRed':nowIndex===index}"
                 v-if="language==='1'">
              {{ item.name_en }}
            </div>
            <div class="line-grey-heng margin-top30"></div>
            <div class="line-title margin-top25" v-if="language==='0'">工作内容</div>
            <div class="line-title margin-top25" v-if="language==='1'">Work Content</div>
            <div class="font-size16 lineH30 color666 margin-top27 line4" v-if="language==='0'">
              {{ item.work_content }}
            </div>
            <div class="font-size16 lineH30 color666 margin-top27 line4" v-if="language==='1'">
              {{ item.work_content_en }}
            </div>
            <div class="flex1"></div>
            <div class="row-me center-all look-div" :class="{'look-div-active':nowIndex===index}">
              <span v-if="language==='0'">查看详情</span>
              <span v-if="language==='1'">Discover More</span>
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk2.png"
                   class="img20 objScaleDown margin-left10" draggable="false"
                   v-if="nowIndex===index">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/zk1.png"
                   class="img20 objScaleDown margin-left10" draggable="false" v-else>
            </div>
            <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_zw.png" class="img-icon"
                 draggable="false">
          </div>
        </div>
        <div class="row-me center-all margin-top50 margin-bottom100">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="prev, pager, next" :total="total" background>
          </el-pagination>
        </div>
      </div>
      <!-- 新闻详情 -->
      <div v-if="showDetail">
        <div class="tab-div row-me row-center">
          <div class="margin-left200">
            <el-breadcrumb separator=">">
              <el-breadcrumb-item :to="{ path: '/home' }">
                {{ language === '0' ? '首页' : 'Homepage' }}
              </el-breadcrumb-item>
              <el-breadcrumb-item>
						<span class="pointer" @click="clickContact">
							{{ language === '0' ? '加入我们' : 'JOIN US' }}</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
						<span style="color: #0B0F0F;font-weight: bold;"
                  v-if="language==='0'">{{ selectItem.name }}</span>
                <span style="color: #0B0F0F;font-weight: bold;"
                      v-if="language==='1'">{{ selectItem.name_en }}</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="margin-left200 margin-right200">
          <div class="font-size30 font-bold margin-top100" v-if="language==='0'">{{ selectItem.name }}</div>
          <div class="font-size30 font-bold margin-top100" v-if="language==='1'">{{ selectItem.name_en }}</div>
          <div class="font-size20 color666 margin-top10">CHENGLONG</div>
          <div class="line-red-heng margin-top20"></div>
          <div class="font-size20 color000 margin-top50" v-if="language==='0'">工作内容</div>
          <div class="font-size20 color000 margin-top50" v-if="language==='1'">Work Content</div>
          <div class="font-size16 color666 margin-top20 lineH30 html-show" v-html="selectItem.work_content"
               v-if="language==='0'"></div>
          <div class="font-size16 color666 margin-top20 lineH30 html-show" v-html="selectItem.work_content_en"
               v-if="language==='1'"></div>
          <div class="font-size20 color000 margin-top50" v-if="language==='0'">职位要求</div>
          <div class="font-size20 color000 margin-top50" v-if="language==='1'">Job Requirements</div>
          <div class="font-size16 color666 margin-top20 lineH30 html-show" v-html="selectItem.need"
               v-if="language==='0'"></div>
          <div class="font-size16 color666 margin-top20 lineH30 html-show" v-html="selectItem.need_en"
               v-if="language==='1'"></div>
          <div class="font-size30 color000 font-bold margin-top60" v-if="language==='0'">
            如果您想申请，请直接与招聘部门联系
          </div>
          <div class="font-size30 color000 font-bold margin-top60" v-if="language==='1'">
            Please contact the recruitment department directly if you want to apply.
          </div>
          <div class="row-me margin-top50">
            <div class="grey-div1 row-me row-center">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_youxiang.png"
                   class="img180 objScaleDown margin-left50" draggable="false">
              <div class="flex1 margin-left50">
                <div class="font-size20 color000" v-if="language==='0'">简历发送至邮箱</div>
                <div class="font-size20 color000" v-if="language==='1'">
                  Please send your resume to the mailbox
                </div>
                <div class="font-size24 color000 font-bold margin-top20">huanshuai.zhao@chenglonggroup.cn</div>
              </div>
            </div>
            <div class="grey-div2 row-me row-center margin-left50">
              <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_dianhua.png"
                   class="img180 objScaleDown margin-left50" draggable="false">
              <div class="flex1 margin-left50">
                <div class="font-size20 color000" v-if="language==='0'">拨打电话给招聘人员</div>
                <div class="font-size20 color000" v-if="language==='1'">Call the recruiter</div>
                <div class="font-size24 color000 font-bold margin-top20">+86-532-6776-1685</div>
              </div>
            </div>
          </div>
          <div class="margin-top100"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      contactArray: [],
      randomItems: [],
      pageNo: 1,
      total: 0,
      showDetail: false, //显示详情页
      selectItem: {},
      language: '', //0中文，1英文
      isMuted: true, //视频是否静音
      isMobile: '', //0电脑，1手机
      tabIndex: 1,
      upForm: null, //上一篇
      nextForm: null, //下一篇
      hoverIndex: null,
      nowIndex: -1,
    }
  },
  watch: {
    navItem: {
      handler: function (newVal, oldVal) {
        if (newVal.link_url === '/contact') {
          this.pageNo = 1
          this.getData()
        }
      }
    },
    $route: {
      handler(to, from) {
        if (to.query.id === null || to.query.id === undefined) {
          this.showDetail = false
        } else {
          this.showDetail = true
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  computed: {
    navItem() {
      return this.$store.state.navItem;
    },
  },
  created() {
    this.isMobile = sessionStorage.getItem("mobile") === '1'
    this.language = sessionStorage.getItem("language")
    document.title = this.navItem.name
    this.pageNo = 1
    this.getData()
  },
  activated() {
    this.language = sessionStorage.getItem("language")
    document.title = this.navItem.name
  },
  mounted() {

  },
  methods: {
    disableContextMenu(event) {
      event.preventDefault();
    },
    mouseenter(index) {
      this.nowIndex = index
    },
    mouseleave() {
      this.nowIndex = -1
    },
    // 点击联系我们
    onClick() {
      this.$router.push({
        path: '/contact'
      })
      const element = document.querySelector('.mobile-title');
      if (this.language == 0) {
        element.innerHTML = '联系我们';
      } else {
        element.innerHTML = 'Contact us';
      }
    },
    setHoverIndex(index) {
      this.hoverIndex = index;
    },
    clearHoverIndex() {
      this.hoverIndex = null;
    },
    // 点击新闻中心
    tabClick(index) {
      this.tabIndex = index;
      this.pageNo = 1
      this.getData()
    },
    clickContact() {
      this.showDetail = false
      this.selectItem = {}
    },
    clickItem(item, index) {
      this.selectItem = item
      this.showDetail = true
      this.$bus.$emit('scrollTo', 650)
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
      this.$bus.$emit('scrollTo', 650)
    },
    //获取数据
    getData() {
      this.$getRequest("/api/recruitList", {
        page: this.pageNo,
        rows: 6,
      }).then((res) => {
        if (res) {
          this.total = res.data.total;
          this.contactArray = res.data.data;
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.contact-mobile {
  .img-bg {
    width: 100%;
    height: 560px;

    .banner-text {
      position: absolute;
      left: 30px;
      top: 336px;

      .line1 {
        width: 54px;
        height: 8px;
        background: #FFFFFF;
      }
    }
  }

  .mainAdd {
    background-color: #fff;
  }

  .main-content {
    .item-contact {
      padding: 30px;
      background: #FFFFFF;
      border-radius: 10px;
      margin-bottom: 40px;
      cursor: pointer;
      border: 1px solid #ECECEC;

      .line-title {
        height: 24px;
        line-height: 24px;
        font-size: 24px;
        color: #000000;
        border-left: 4px solid #D60110;
        padding-left: 10px;
      }

      .look-div {
        padding: 0 15px;
        line-height: 50px;
        text-align: center;
        border-radius: 25px;
        border: 1px solid #BFBFBF;
        font-size: 22px;
        color: #666666;
        width: fit-content;
        margin-top: 30px;
        margin-bottom: 40px;

        &-active {
          background: #D60110;
          color: #FFFFFF;
          border: 1px solid #D60110;
        }
      }

      .img-icon {
        width: 180px;
        height: 120px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
  }

  .tab-div {
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #ECECEC;
  }

  .line-red-heng {
    width: 40px;
    height: 6px;
    background: #D60110;
  }

  .grey-div1 {
    width: 100%;
    height: 130px;
    background: #F4F4F4;
  }

  .grey-div2 {
    width: 100%;
    height: 130px;
    background: #F4F4F4;
  }
}

.contact {
  .img-bg {
    width: 100%;
    height: 750px;

    .banner-text {
      position: absolute;
      left: 200px;
      top: 370px;

      .line1 {
        width: 54px;
        height: 8px;
        background: #FFFFFF;
      }
    }
  }

  .mainAdd {
    background-color: #fff;
  }

  .main-content {
    .item-contact {
      width: 390px;
      height: 375px;
      padding: 30px;
      background: #FFFFFF;
      border-radius: 10px;
      margin-bottom: 50px;
      margin-left: 25px;
      margin-right: 25px;
      cursor: pointer;
      border: 1px solid #ECECEC;

      &:hover {
        box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.2);
      }

      .line-title {
        height: 24px;
        line-height: 24px;
        font-size: 24px;
        color: #000000;
        border-left: 4px solid #D60110;
        padding-left: 10px;
      }

      .look-div {
        padding: 0 15px;
        line-height: 40px;
        text-align: center;
        border-radius: 20px;
        border: 1px solid #BFBFBF;
        font-size: 16px;
        color: #666666;
        width: fit-content;
        margin-top: 20px;
        margin-bottom: 20px;

        &-active {
          background: #D60110;
          color: #FFFFFF;
          border: 1px solid #D60110;
        }
      }

      .img-icon {
        width: 180px;
        height: 120px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
  }

  .tab-div {
    width: 100%;
    height: 80px;
    background: #F4F4F4;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
    border-radius: 0px;
  }

  .line-red-heng {
    width: 40px;
    height: 6px;
    background: #D60110;
  }

  .grey-div1 {
    width: 850px;
    height: 180px;
    background: #F4F4F4;
  }

  .grey-div2 {
    width: 620px;
    height: 180px;
    background: #F4F4F4;
  }
}
</style>
